import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 200); // Simulate fade-in effect on load
  }, []);

  return (
    <div
      className={`vh-100 d-flex align-items-center justify-content-center bg-dark position-relative ${
        loaded ? "fade-in" : ""
      }`}
      style={{
        textAlign: "center",
        color: "white",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: 'url("shop/images/logo/logo-roys-transparent.png") no-repeat center',
          backgroundSize: "contain",
          opacity: 0.1,
        }}
      ></div>

      {/* Content */}
      <div className="position-relative z-2">
        <img
          src="shop/images/logo/logo-roys-transparent.png"
          alt="Elite World"
          className="img-fluid logo-animate mb-4"
          style={{
            maxWidth: "180px",
            filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.5))",
          }}
        />
        <h1
          className="display-4 fw-bold text-glow"
          style={{
            textShadow: "2px 2px 10px rgba(0, 0, 0, 0.8)",
          }}
        >
          Welcome to Elite World
        </h1>
        <button
          className="btn btn-primary mt-4 px-4 py-2 button-hover"
          onClick={() => navigate("auths/login")}
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            borderRadius: "8px",
            padding: "12px 24px",
            transition: "all 0.3s ease-in-out",
          }}
        >
          Logout
        </button>
      </div>

      {/* Custom CSS (Inline) */}
      <style>
        {`
          /* Fade-in effect */
          .fade-in {
            opacity: 0;
            animation: fadeIn 1.2s ease-in-out forwards;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }

          /* Logo zoom-in animation */
          .logo-animate {
            animation: zoomIn 1.2s ease-in-out;
          }

          @keyframes zoomIn {
            from { transform: scale(0.8); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }

          /* Text glow effect */
          .text-glow {
            animation: textGlow 2s infinite alternate;
          }

          @keyframes textGlow {
            from { text-shadow: 0 0 10px rgba(255, 255, 255, 0.5); }
            to { text-shadow: 0 0 20px rgba(255, 255, 255, 1); }
          }

          /* Button hover effect */
          .button-hover:hover {
            transform: scale(1.1);
            box-shadow: 0 0 15px rgba(0, 123, 255, 0.7);
          }
        `}
      </style>
    </div>
  );
};

export default HomePage;
